module.exports = __webpack_public_path__ + "img/Image_15.e8099bbb.png";